import React, {useEffect} from 'react'
import {useTranslation} from "react-i18next";
import {Box, Grid, Typography} from "@mui/material";
import Subtitle from "../../components/Subtitle";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {getCurrentLanguage} from "../../utils/Helpers";

const StructureGrowthLayout = ( ) =>{
    const dispatch = useAppDispatch();
    const {i18n}= useTranslation();
    let key = getCurrentLanguage(i18n);
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/structure-growth",
            type:"pageView"
        }))
    }, []);
    const {t} =useTranslation();
    return(
        <React.Fragment>
            <Box component="main">
                <Subtitle/>
                <br/>
                <br/>
                <Typography variant="h4" style={{fontWeight: "bold"}}>
                    {t('structure_growth.title' as any)}
                </Typography>
                <br/>
                <br/>
                <Typography variant="h6">
                    {t('structure_growth.subtitle1' as any)}
                </Typography>
                <Typography paragraph>
                    {t('structure_growth.subtitle1_description' as any)}
                </Typography>

                <br/>

                <Typography variant="h6">
                    {t('structure_growth.subtitle2' as any)}
                </Typography>

                <Typography paragraph>
                    {t('structure_growth.subtitle2_description' as any)}
                  </Typography>


                <Grid container alignItems='center' justifyContent='center'>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                maxWidth: "95%"
                            }}
                            component="img"
                            alt="Table Sealing 1"
                            src={require("../../assets/pages/detail/structure_growth/"+key+"/diameter-height.png")}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                maxWidth: "95%"
                            }}
                            component="img"
                            alt="Table Sealing 1"
                            src={require("../../assets/pages/detail/structure_growth/"+key+"/diameter-crown.png")}
                        />
                    </Grid>
                </Grid>

                <Grid container alignItems='center' justifyContent='center'>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                maxWidth: "95%"
                            }}
                            component="img"
                            alt="Table Sealing 1"
                            src={require("../../assets/pages/detail/structure_growth/"+key+"/diameter-crown-projection.png")}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                maxWidth: "95%"
                            }}
                            component="img"
                            alt="Table Sealing 1"
                            src={require("../../assets/pages/detail/structure_growth/"+key+"/diameter-crown-volume.png")}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                        <Box
                            component="img"
                            alt="Table Sealing 1"
                            src={require("../../assets/pages/detail/structure_growth/"+key+"/diameter-legend.png")}
                        />
                </Grid>
                <br/>
                <Typography paragraph sx={{fontStyle:"italic"}}>
                    {t('structure_growth.diagram_1' as any)}
                </Typography>

            </Box>
        </React.Fragment>
    )
}
export default StructureGrowthLayout
